import { useEffect, useState } from 'react'

import { useStep } from '../../hooks/use-step'
import { Step } from '../../utils/steps'
import { BottomText } from '../title-and-text/bottom-text'

import { ChatInput } from './chat-input'
import { ChatThread } from './chat-thread'
import { Stage } from './constants'
import { ContextMenu } from './context-menu'

import style from './super-human-go.module.scss'

const SuperhumanGo = () => {
  const { step } = useStep()
  const [stage, setStage] = useState(Stage.START)

  const startStayVisibleDuration = 500
  const resetDelay = 1000

  useEffect(() => {
    if (step !== Step.AgentsGo) {
      setStage(Stage.START)
      return
    }

    let timeoutId: NodeJS.Timeout
    if (stage === Stage.START) {
      timeoutId = setTimeout(() => {
        setStage(Stage.ADD_SOURCE)
      }, startStayVisibleDuration)
    } else if (stage === Stage.RESET) {
      timeoutId = setTimeout(() => {
        setStage(Stage.START)
      }, resetDelay)
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [step, stage])

  return (
    <div className={style.container} data-step={Step.AgentsGo}>
      <div className={style.chatContainer}>
        <ChatThread stage={stage} />
        <ChatInput stage={stage} setStage={setStage} />
        <ContextMenu stage={stage} setStage={setStage} />
      </div>
      <BottomText>
        Get help with everything you're working on <br /> without leaving your window.
      </BottomText>
    </div>
  )
}

export default SuperhumanGo
